<template>
  <div class="about-us-page">
    <AccountPageTopBar :title="$t('accountSettings.aboutUs')" @back="goBack" />

    <main class="about-us-page__content">
      <section class="about-us-hero">
        <img
          class="about-us-brand"
          src="@/assets/img/profile/account/about-us-brand-logo.png"
          :alt="$t('appName')"
        >
        <span class="about-us-hero__divider"></span>
        <p>{{ $t('aboutUs.description') }}</p>
        <div class="about-us-skyline" aria-hidden="true">
          <span v-for="height in skylineHeights" :key="height" :style="{ height: `${height}px` }"></span>
        </div>
      </section>

      <section class="about-us-actions">
        <button type="button" @click="openWebsite">
          <span class="about-us-actions__icon"><img src="@/assets/img/profile/account/website.svg" alt=""></span>
          <span class="about-us-actions__copy">
            <strong>{{ $t('aboutUs.officialWebsite') }}</strong>
            <small class="is-link">{{ websiteUrl }}</small>
          </span>
          <Icon class="about-us-actions__arrow" name="arrow" />
        </button>
        <div class="about-us-actions__row">
          <span class="about-us-actions__icon"><img src="@/assets/img/profile/account/email.svg" alt=""></span>
          <span class="about-us-actions__copy">
            <strong>{{ $t('aboutUs.contactUs') }}</strong>
            <small>{{ supportEmail }}</small>
          </span>
          <span class="about-us-actions__spacer"></span>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import { Icon } from 'vant';
import AccountPageTopBar from '@/components/AccountPageTopBar/index.vue';
import routerBack from '@/mixins/routerBack';

const WEBSITE_URL = 'https://www.genggo.id/';
const SUPPORT_EMAIL = 'support@genggo.id';

export default {
  name: 'ProfileAboutUs',
  mixins: [routerBack],
  components: {
    AccountPageTopBar,
    Icon,
  },
  data() {
    return {
      websiteUrl: WEBSITE_URL,
      supportEmail: SUPPORT_EMAIL,
      skylineHeights: [42, 28, 36, 24, 40, 30, 48, 34, 26, 44, 32, 38],
    };
  },
  methods: {
    openWebsite() {
      try {
        const openedWindow = window.open(WEBSITE_URL, '_blank');
        if (!openedWindow) throw new Error(this.$t('aboutUs.openFailed'));
        try {
          openedWindow.opener = null;
        } catch {
          // Some browsers prevent changing the opener on an external page.
        }
      } catch (error) {
        this.$toast(error?.message || this.$t('aboutUs.openFailed'));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.about-us-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
  color: #070d3f;
}

.about-us-page__content {
  padding: 248px 16px calc(48px + env(safe-area-inset-bottom));
}

.about-us-hero {
  text-align: center;

  > p {
    max-width: 620px;
    margin: 60px auto 0;
    color: #070d3f;
    font-size: 26px;
    font-weight: 400;
    line-height: 40px;
    white-space: pre-line;
  }
}

.about-us-brand {
  display: block;
  width: 100%;
  max-width: 686px;
  height: 236px;
  margin: 0 auto;
  object-fit: contain;
}

.about-us-hero__divider {
  display: block;
  width: 52px;
  height: 6px;
  margin: 116px auto 0;
  border-radius: 999px;
  background: #0b45ff;
}

.about-us-skyline {
  display: flex;
  height: 112px;
  margin-top: 48px;
  align-items: flex-end;
  justify-content: space-between;
  gap: 10px;

  span {
    flex: 1;
    border-radius: 8px 8px 0 0;
    background: #eaf3ff;
  }
}

.about-us-actions {
  overflow: hidden;
  margin-top: 92px;
  padding: 0 16px;
  border: 2px solid #e5eaf3;
  border-radius: 20px;
  background: #ffffff;

  button,
  &__row {
    display: flex;
    width: 100%;
    min-height: 112px;
    align-items: center;
    padding: 16px;
    border: 0;
    background: transparent;
    color: #070d3f;
    text-align: left;
    box-sizing: border-box;
  }

  button {
    border-bottom: 2px solid #e5eaf3;
  }
}

.about-us-actions__icon {
  display: flex;
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  background: #eaf3ff;
  color: #0b45ff;
  font-size: 30px;

  img {
    width: 30px;
    height: 30px;
  }
}

.about-us-actions__copy {
  min-width: 0;
  margin-left: 16px;
  flex: 1;

  strong,
  small {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  strong {
    font-size: 26px;
    font-weight: 500;
    line-height: 36px;
  }

  small {
    color: #6b7280;
    font-size: 24px;
    line-height: 32px;

    &.is-link {
      color: #0b45ff;
    }
  }
}

.about-us-actions__arrow,
.about-us-actions__spacer {
  width: 36px;
  margin-left: 12px;
  flex-shrink: 0;
  color: #6b7280;
  font-size: 32px;
}

</style>
